import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray } from '../../../../utils';

// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Filter from '../../../CaseBody/CaseHistory/Grid/Filter';
import ReactTable from '../../../CaseBody/CaseHistory/Grid/Table/';

//action Creator
import { setDarkTitleBarContent } from '../../../layouts/actions/actionCreator';
//style
import './CaseHistory.css';
import '../../../CaseBody/CaseHistory/Grid/Table/index.css';

class CaseHistory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      entityData: [],
      saveCommentStatus: true,
      eventType: "All events",
      userType: "All users"
    };
  }

  loadData = () => {
    /*let caseOwner = [
      {
        "id":"All Users",
        "value":"All Users"
      },
      {
        "id": this.props.darkTitleBar.currentCase.caseOwner.name,
        "value":  this.props.darkTitleBar.currentCase.caseOwner.name
      }
    ]*/

    var url;
    if (this.props.history.location.pathname.includes("sow-body")) {
      var sowId = this.props.match.params.sowId
      url = `/sows/${sowId}/caseHistory?clientsphere=true`;
    }
    else {
      var caseId = this.props.match !== undefined ? this.props.match.params.Urn : this.props.caseId;
      url = `/cases/${caseId}/caseHistory?clientsphere=true`;
    }

    let langParam = '';

    if (this.props.lang.currentLang.lang === "Spanish") {
      langParam = '?lang=es';
    } else if (this.props.lang.currentLang.lang === "Bahasa") {
      langParam = '?lang=ba';
    }

    eapiClient(url + langParam)
      .then(({ data }) => {
        let usersList = [];
        Object.keys(data.responseData.data.users).map(key => {
          usersList[key] = {
            "id": data.responseData.data.users[key],
            "value": data.responseData.data.users[key]
          }
        });
        usersList.unshift({
          id: "All users",
          value: "All users"
        });

        this.setState({
          data: data.responseData.data.caseHistory || [],
          filterData: data.responseData.data.caseHistory || [],
          caseOwner: usersList || [],
          eventStatus: data.responseData.eventType,
          entityData: data.responseData.data.caseHistory || []
        });
      });

  }

  componentWillMount() {

    aemHostClient("/aemData/formData/json_manual-case-case-history")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });


    try {
      this.loadData();
      let heading;
      const currentCase = this.props.cases[(Object.keys(this.props.cases))[0]];
      if (Object.keys(this.props.cases).length > 1) {
        const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
        heading = `${currentCase.entityName} (+${noOfCasesExcludingRoot} others)`;
      } else {
        heading = currentCase.entityName;
      }
      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data, status }) => {
          this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
        });
    }
    catch (e) {
    }

  }
  getStatusOnchange = (filter) => {
    this.setState({
      eventType: filter
    })
    if (filter.length > 0 && filter !== 'All events') {
      if (this.state.userType === 'All users') {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      } else {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === filter.toLowerCase() && caseHistory.userId.toLowerCase() === this.state.userType.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      }
    } else if (this.state.userType === 'All users' && filter === 'All events') {
      this.setState({
        data: this.state.filterData,
      });
    } else if (filter.length > 0 && filter === 'All events') {
      let filteredDataObject = this.state.filterData.filter(caseHistory => {
        return caseHistory.userId.toLowerCase() === this.state.userType.toLowerCase();
      });
      this.setState({
        data: filteredDataObject,
        entityData: filteredDataObject
      });
    }
  }

  getStatusOnUserchange = (filter) => {
    this.setState({
      userType: filter
    })
    if (filter.length > 0 && filter !== 'All users') {
      if (this.state.eventType === 'All events') {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.userId.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      } else {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === this.state.eventType.toLowerCase() && caseHistory.userId.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      }
    } else if (filter === 'All users' && this.state.eventType === 'All events') {
      this.setState({
        data: this.state.filterData,
      });
    } else if (filter.length > 0 && filter === 'All users') {
      let filteredDataObject = this.state.filterData.filter(caseHistory => {
        return caseHistory.eventType.toLowerCase() === this.state.eventType.toLowerCase();
      });
      this.setState({
        data: filteredDataObject,
        entityData: filteredDataObject
      });
    }
  }

  columnsHeader = () => {
    let fieldData;
    let confieldData;

    let columns = [
      { accessor: "lastUpdatedOn" },
      {
        id: "caseId",
        accessor: d => d.caseId
      },
      { accessor: "userId" },
      { accessor: "eventType" },
      { accessor: "eventDetail" }
    ]
    if (this.state.pageJson !== '' && this.state.pageJson !== undefined) {
      fieldData = Translations(this.state.pageJson.table_caseHistoryTable.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData)
      confieldData = convertStringToArray(fieldData);
      if (!(Object.keys(this.state.pageJson).length === 0 && this.state.pageJson.constructor === Object)) {
        for (let i = 0; confieldData.length > i; i++) {
          columns[i].Header = confieldData[i];
        }
      }
      return columns;
    }
    return columns;
  }

  saveComment = (data) => {
    var requestPayload = {
      id: this.props.caseId,
      lastUpdatedOn: new Date().getTime,
      caseId: this.props.darkTitleBar.currentCase.caseId,
      userId: this.props.loginDetails.username,
      eventType: "Added Comment",
      eventDetail: this.state.userComment
    }

    eapiClient("/cases/caseHistory", {
      method: "POST",
      data: JSON.stringify(requestPayload)
    })
      .then(({ data }) => {
        this.setState({
          userComment: "",
          saveCommentStatus: true
        });
        eapiClient(`/cases/${this.props.caseId}/caseHistory?clientsphere=true`)
          .then(({ data }) => {

            let usersList = [];
            Object.keys(data.responseData.data.users).map(key => {
              usersList[key] = {
                "id": data.responseData.data.users[key],
                "value": data.responseData.data.users[key]
              }
            });
            usersList.unshift({
              id: "All users",
              value: "All users"
            });

            this.setState({
              caseOwner: usersList || [],
              eventStatus: data.responseData.eventType,
              data: data.responseData.data.caseHistory || [],
              filterData: data.responseData.data.caseHistory || [],
              entityData: data.responseData.data.caseHistory || []
            });
            this.getStatusOnUserchange(this.state.userType);
            this.getStatusOnchange(this.state.eventType);
          });
      })





  }

  resetCommentBox = () => {
    this.setState({
      userComment: ""
    });
  }

  filterByEntity = (caseId) => {
    if (caseId !== 'all') {
      let data = this.state.entityData.filter((item) => {
        return caseId === item.id;
      });
      this.setState({
        data: data
      });
    } else {
      this.setState({
        data: this.state.entityData
      });
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData);
  }

  resetAllData = () => {
    this.loadData();
  }

  handleChange = event => {
    if (event.target.value.trim().length > 0) {
      this.setState({
        saveCommentStatus: false
      });
    } else {
      this.setState({
        saveCommentStatus: true
      });
    }
    this.setState({
      userComment: event.target.value
    });
  }

  render() {
    let styleBtn = {
      marginTop: "3px"
    }
    let tablejsx = (<h3>Loading...</h3>);
    let tableFilter = (<h3>Loading...</h3>);
    let pageJsxForManuaLCase;

    if (this.state.pageJson !== '' &&
      this.state.pageJson !== undefined) {
      tableFilter = (
        <Filter
          pageJson={this.state.pageJson}
          eventStatus={this.state.eventStatus}
          caseOwner={this.state.caseOwner}
          getStatusOnchange={(str) => this.getStatusOnchange(str)}
          getStatusOnUserchange={(str) => this.getStatusOnUserchange(str)}
          entitiesList={this.props.entitiesList}
          cases={this.props.cases}
          filterByEntity={(caseId) => this.filterByEntity(caseId)}
          lang={this.props.lang}
          resetAllData={this.resetAllData}
        />);
    }

    tablejsx = (
      <ReactTable
        data={this.state.data}
        pageJsonContent={this.state.pageJson}
        columns={this.columnsHeader()}
        lang={this.props.lang}
      />
    );
    if (this.state.pageJson !== undefined) {
      pageJsxForManuaLCase = <div className="gdoc-manual-case-history-container">
        <div className="gdoc-manual-case-history" >
          {tableFilter}
          {tablejsx}
        </div>
        <div className="gdoc-case-history-commentBox">
          <label className="commentBox gdocs-mbottom-10">{this.translations(this.state.pageJson.guidetextbox_CommentBox.title)}</label>
          <textarea
            type="text"
            tabIndex="0"
            rows="14"
            cols="10"
            wrap="soft"
            maxLength={this.state.pageJson.guidetextbox_CommentBox.maxChars}
            id="commentBox"
            onChange={this.handleChange}
            value={this.state.userComment}
            className="form-control form-control-lg"
          /></div>
        <div className="history-commentBox-btn">
          <button
            type="button"
            className="gdocs-btn-submit case-history-btn"
            onClick={(data) => this.saveComment(data)}
            name="saveComments"
            disabled={this.state.saveCommentStatus}
          >
            {this.translations(this.state.pageJson.guidebutton_saveChanges.text)}
          </button>
          <button
            type="button"
            className="gdocs-btn-cancel case-history-btn"
            onClick={this.resetCommentBox}
            name="cancelComments"
          >
            {this.translations(this.state.pageJson.guidebutton_cancel.text)}
          </button>
        </div></div>
    }

    return (
      (
        this.state.pageJson !== undefined
          ? pageJsxForManuaLCase
          : ''
      )
    );
  }
}

const mapStateToProps = state => {
  let entitiesList = [];
  entitiesList = (Object.keys(state.entities)).map(entityId => {
    const { caseId, entityName } = state.entities[entityId];
    return { entityId, caseId, entityName };
  });
  entitiesList.unshift({
    caseId: 'all',
    entityName: 'All'
  });
  return {
    cases: state.cases,
    darkTitleBar: state.darkTitleBar,
    entitiesList,
    lang: state.lang,
    caseId: state.newManualCase.caseId,
    loginDetails: state.auth.userDetails
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseHistory);


// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/SubComp/CaseHistory.js